import { Icon, Text, Box } from '@nimbus-ds/components';
import { RepeatIcon } from '@nimbus-ds/icons';
import { useTranslationCatalog } from 'domains/Catalog/hooks';

export function MetaplansListEmpty(): JSX.Element {
  const t = useTranslationCatalog();

  return (
    <Box
      alignItems="center"
      display="flex"
      justifyContent="center"
      width="100%"
      flexDirection="column"
      gap="2"
      paddingTop="8"
    >
      <Icon color="neutral-textDisabled" source={<RepeatIcon size="large" />} />
      <Box
        alignItems="center"
        display="flex"
        gap="2"
        flexDirection="column"
        width="100%"
        maxWidth="500px"
        padding="4"
      >
        <Text
          color="neutral-textHigh"
          textAlign="center"
          fontWeight="bold"
          fontSize="highlight"
        >
          {t('subscriptions.empty.title')}
        </Text>
        <Text color="neutral-textLow" textAlign="center" fontSize="base">
          {t('subscriptions.empty.description')}
        </Text>
      </Box>
    </Box>
  );
}
